export default __webpack_public_path__ + "static/media/jquery.eb105fbb.png";